<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="lg:max-w-xl">
            <BackButtonDesktop @clickBack="clickBack()"></BackButtonDesktop>
            <div class="p-4">
                <AddressList
                    ref="address-list"
                    @onEditAddress="clickEditAddress($event)"
                    @onDeleteAddress="clickDeleteAddress($event)"
                    @onLoaded="onLoaded()" 
                ></AddressList>
                <div class="w-52 mx-auto pt-4">
                    <WhiteButton @click="clickAddAddress()"
                        customClass="flex p-2 mx-auto">
                        <img class="ml-auto mr-2" src="@/assets/icon/ic-add-red-2.svg" />
                        <div class="ml-0 mr-auto text-a-red-d62300 text-14 font-bold">{{lbl.shipping.headline_add}}</div>
                    </WhiteButton>
                </div>
            </div>
            
        </MainPage>
    </div>
</template>
<script>
//helper
import Util from "@/helper/Utility.js";
//component
import MainPage from "@/components/Layout/Page/MainPage.vue";
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'
import AddressList from "../component/AddressList.vue";
import WhiteButton from "@/components/Button/WhiteButton.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import DeliveryMixin from '@/mixin/DeliveryMixin';
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "DeliveryAddress",
    mixins: [ModalMixin,DeliveryMixin,AuthStatusMixin,LocaleMixin],
    components: {
        MainPage,
        BackButtonDesktop,
        AddressList,
        WhiteButton
    },
    mounted: function() {
        Util.scrollTop();
    },
    methods: {
        onAccountInit: async function() {
            // if (this.isFromDeliveryMethod) {
            //     this.checkEditFromDeliveryMethod();
            // }
        },
        checkEditFromDeliveryMethod: function() {
            if (this.delivery.address == null) {
                this.updateIsFromDeliveryMethod(false);
                this.$router.push("/location");
            }
        },
        onLoaded: function() {
            let addressList = this.$refs["address-list"].getList();
            if (addressList.length == 0) {
                if (this.isFromDeliveryMethod) {
                    this.checkEditFromDeliveryMethod();
                }
            }
        },
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialAddressModal();
        },
        //#endregion mixin function

        reloadAddressList: function() {
            this.$refs['address-list'].getAddressList();
        },

        clickAddAddress: function() {
            this.$router.push('/location');
            // this.modal.addAddressModal.clearModal().show();
            // this.modal.addAddressModal.onAddSuccess(() => {
            //     this.reloadAddressList();
            // });
        },
        clickEditAddress: function(address) {
            console.log(address)
            this.$router.push('/editaddress');
        },
        clickDeleteAddress: function(address) {
            this.modal.confirmModal.clearModal()
                    .setMsg(this.lbl.shipping.confirm_delete_msg)
                    .setBtnOk(this.lbl.shipping.confirm_ok_btn)
                    .show();
            this.modal.confirmModal.onClickOk(() => {
                this.apiDeleteAddress(address);
            });
        },

        apiDeleteAddress: function(address) {
            this.modal.loadingModal.show();

            BzbsAddressList.apiDeleteAddress(address.rowKey).subscribe({
                next: () => {
                    this.modal.loadingModal.hide();
                    this.reloadAddressList();
                },
                error: (err) => {
                    this.modal.loadingModal.hide();
                    this.errorApi(err);
                }
            });
        },

        clickListAddressModal: function() {
            this.modal.listAddressModal.show();
        },
        clickBack: function() {
            this.updateIsFromDeliveryMethod(false);
            this.$router.back();
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
